export enum eCompressionFailReason {
  UNSUPPORTED_TYPE = 'unsupported-type',
  INPUT_TOO_LARGE = 'input-too-large',
  ENCODER_UNAVAILABLE = 'encoder-unavailable',
  VIDEO_TOO_LONG = 'video-too-long',
  OUTPUT_TOO_LARGE = 'output-too-large',
  PROCESSING_ERROR = 'processing-error',
  // The container decodes but carries no video stream (an audio-only .mp4);
  // Meta answers 131053 "No video stream found".
  NO_VIDEO_TRACK = 'no-video-track',
}

export type tCompressToLimitRequest = {
  file: File;
  maxBytes: number;
  onProgress?: (progress: number) => void;
};

export type tNormalizeForChannelRequest = tCompressToLimitRequest & {
  channel: string | undefined;
};

export type tCompressMediaSuccess = {
  ok: true;
  file: File;
  wasCompressed: boolean;
  originalBytes: number;
  finalBytes: number;
};

export type tCompressMediaFailure = {
  ok: false;
  reason: eCompressionFailReason;
  // Underlying error message (e.g. what the HEIC decoder actually threw), for
  // diagnostics. `reason` is a coarse enum; `cause` preserves the real signal
  // so logs distinguish a corrupt file from a decoder chunk that failed to load.
  cause?: string;
};

export type tCompressMediaResult = tCompressMediaSuccess | tCompressMediaFailure;

export type tNormalizeImageSuccess = {
  ok: true;
  file: File;
  // true when the file was decoded + re-encoded (HEIC→JPEG); false when it
  // passed through untouched (already a browser-renderable format).
  wasTranscoded: boolean;
};

export type tNormalizeImageResult =
  | tNormalizeImageSuccess
  | tCompressMediaFailure;

export type tVideoBitrateBudgetOptions = {
  maxBytes: number;
  durationSeconds: number;
  audioBitrate: number;
};

export type tTargetWidthOptions = {
  width: number;
  height: number;
  longestEdgeCap: number;
};
